export const AddAnimationComponent = (instance) => {
  const scenes = instance.engine.scene.createVideo();
  const page = instance.engine.block.create("page");

  instance.engine.block.setWidth(page, 1920);
  instance.engine.block.setHeight(page, 1080);
  instance.engine.block.appendChild(scenes, page);

  // this will change the background color of std
  // instance.engine.editor.setSettingColor("clearColor", {
  //   r: 0.2,
  //   g: 0.2,
  //   b: 0.2,
  //   a: 1,
  // });
  const graphic = instance.engine.block.create("graphic");
  const imageFill = instance.engine.block.createFill("image");
  instance.engine.block.setFill(graphic, imageFill);
  instance.engine.block.setShape(
    graphic,
    instance.engine.block.createShape("rect")
  );
  //   instance.engine.block.setWidth(graphic, 500);
  //   instance.engine.block.setHeight(graphic, 500);
  //   instance.engine.block.setPositionX(graphic, (1920 - 500) / 2);
  //   instance.engine.block.setPositionY(graphic, (1080 - 500) / 2);
  //   instance.engine.block.appendChild(page, graphic);

  //instance.engine.scene.zoomToBlock(page, 60, 60, 60, 60);

  const slideInAnimation = instance.engine.block.createAnimation("slide");
  const breathingLoopAnimation =
    instance.engine.block.createAnimation("breathing_loop");
  const fadeOutAnimation = instance.engine.block.createAnimation("fade");

  instance.engine.block.setInAnimation(graphic, slideInAnimation);
  instance.engine.block.setLoopAnimation(graphic, breathingLoopAnimation);
  // highlight-setOutAnimation
  instance.engine.block.setOutAnimation(graphic, fadeOutAnimation);
  // highlight-setOutAnimation
  const animation = instance.engine.block.getLoopAnimation(graphic);
  const animationType = instance.engine.block.getType(animation);

  const squeezeLoopAnimation =
    instance.engine.block.createAnimation("squeeze_loop");
  instance.engine.block.destroy(
    instance.engine.block.getLoopAnimation(graphic)
  );
  instance.engine.block.setLoopAnimation(graphic, squeezeLoopAnimation);
  /* The following line would also destroy all currently attached animations */
  // instance.engine.block.destroy(graphic);

  // const allAnimationProperties =
  //   instance.engine.block.findAllProperties(slideInAnimation);
  // instance.engine.block.setFloat(
  //   slideInAnimation,
  //   "animation/slide/direction",
  //   0.5 * Math.PI
  // );

  instance.engine.block.setDuration(slideInAnimation, 0.6);
  instance.engine.block.setEnum(slideInAnimation, "animationEasing", "EaseOut");
  console.log(
    "Available easing options:",
    instance.engine.block.getEnumValues("animationEasing")
  );

  instance.engine.block.setPlaying(page, true);
  instance.engine.block.setLooping(page, true);
};
